<div class="max-w-screen-md block m-auto pt-24 pb-24">
  <p class="font-sans text-l text-eggplant-100/[0.4] text-center pb-24">{{ 'OVERVIEW.DOCS_TXT' | translate }}</p>
  <div class="documents-table appear border border-eggplant-100/[0.1] bg-white rounded-2xl">
    <div *ngFor="let file of files" (click)="openFile(file)"
      class="row-table flex items-center bg-white rounded-2xl relative cursor-pointer">
      <div class="icon-content rounded-2xl">
        <fun-icon [name]="'file'" [style]="'w-32 h-32 stroke-[4px] stroke-[#29141F]'"></fun-icon>
      </div>
      <p class="w-full font-sans text-l md:text-2xl text-eggplant-100 pr-48">{{ file.name }}</p>
      <div class="absolute right-[24px] top-1/2 -translate-y-1/2">
        <fun-icon [name]="'download'" [style]="'w-20 h-20 stroke-[2px] stroke-eggplant-100'"></fun-icon>
      </div>
    </div>
  </div>
</div>
